import React from 'react';
import styled from 'styled-components';
import {ZoomInIcon, ZoomOutIcon} from '../../UI/Icons';
import {motion} from 'framer-motion';
import {tabletWidth} from '../../mixins';


const StyledControlsWrapper = styled.div`
   position: absolute;
   bottom: 100px;
   right: 24px;
   z-index: 1400;
   display: flex;
   flex-direction: column;
   justify-content: space-between;
   align-items: center;
   height: 130px;
   
   @media screen and (max-width: ${tabletWidth}) {
    right: 6px;
   }
   
   @media screen and (max-width: ${tabletWidth}) and (orientation: landscape) {
    right: 6px;
    bottom: 20px;
   }
`


const StyledControl = styled(motion.button)`
   width: auto;
   border-radius: 100px;
   border: none;
   background-color: transparent;
   cursor: pointer;
   padding: 0;
   
   svg {
      border-radius: 100px;
      box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.08), 16px 16px 16px rgba(97, 119, 122, 0.08);
   }
`


const ZoomInControl = ({map}) => {

    const onZoomInClick = () => map.setZoom(map.getZoom() + 1);
    const onZoomOutClick = () => map.setZoom(map.getZoom() - 1);


    return (
        <StyledControlsWrapper>
            <StyledControl whileHover={{scale: 1.1}} whileTap={{scale: 0.9}} onClick={onZoomInClick} id='continue-button'>
                {ZoomInIcon}
            </StyledControl>
            <StyledControl whileHover={{scale: 1.1}} whileTap={{scale: 0.9}} onClick={onZoomOutClick} id='continue-button'>
                {ZoomOutIcon}
            </StyledControl>
        </StyledControlsWrapper>

    )
};

export default ZoomInControl;